import { useEffect, useMemo } from 'react';
import { get } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { Asset, Liability } from '@funnels/types';

import { useFormValues } from '../useFormValues';

export function useHydrateCurrentAddress(applicantIndex: number) {
  const [formValues, setFormValue] = useFormValues();
  const assets = useMemo(() => get(formValues, FIELD_PATHS.ASSETS(), []), [formValues]);

  useEffect(() => {
    const currentAddress = get(formValues, FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_RESIDENTIAL(applicantIndex));

    if (currentAddress) {
      return;
    }

    const propertyIndex = assets.findIndex((a: Asset, index: number) => {
      const toBeUsedAsSecurity = get({ assets }, FIELD_PATHS.ASSET_USED_AS_SECURITY(index), false);
      const toBePurchased = get({ assets }, FIELD_PATHS.ASSET_TO_BE_PURCHASED(index), false);
      const primaryPurpose = get({ assets }, FIELD_PATHS.ASSET_PRIMARY_PURPOSE(index));
      const isOwnerOccupied = primaryPurpose === FIELD_VALUES.OWNER_OCCUPIED;

      return toBeUsedAsSecurity && !toBePurchased && isOwnerOccupied;
    });

    if (propertyIndex !== -1) {
      const propertyId = get({ assets }, FIELD_PATHS.ASSET(propertyIndex)).clientId;
      const address = get({ assets }, FIELD_PATHS.ASSET_ADDRESS(propertyIndex));
      const liability = get(formValues, FIELD_PATHS.LIABILITIES(), []).find((l: Liability) =>
        l.assetClientId.includes(propertyId)
      );

      setFormValue(FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_RESIDENTIAL(applicantIndex), address);

      if (liability) {
        setFormValue(
          FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_HOUSING_STATUS(applicantIndex),
          FIELD_VALUES.OWN_HOME_MORTGAGE
        );
      } else {
        setFormValue(FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_HOUSING_STATUS(applicantIndex), FIELD_VALUES.OWN_HOME);
      }
    }
  }, [assets]);
}

export function useUpdateEndDates(applicantIndex: number, addressesCount: number) {
  const [formValues, setFormValue] = useFormValues();
  const applicant = get(formValues, FIELD_PATHS.APPLICANT(applicantIndex));

  useEffect(() => {
    let endDate: string;

    [...new Array(addressesCount)].forEach((__: any, index: number) => {
      if (index === 0) {
        endDate = get(formValues, FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_START_DATE(applicantIndex));
      } else {
        setFormValue(FIELD_PATHS.APPLICANT_PREVIOUS_ADDRESS_END_DATE(applicantIndex, index - 1), endDate);
        endDate = get(formValues, FIELD_PATHS.APPLICANT_PREVIOUS_ADDRESS_START_DATE(applicantIndex, index - 1));
      }
    });
  }, [applicant]);
}
